import logo from "./images/header_logo.png"
import homeImage from "./images/main_page.png"

export default {
    logo: logo,
    homeImage: homeImage,
    name: "rata services",
    title: "Rata Services Central view",
    titleFont: "Poppins",
    bodyFont: "Open Sans"
  };